import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import { version } from "../../../package.json";

const state = {
  initPage: false,
  fullPageLoading: false,
  params: null,
  paramsCount: null,
  serverVersion: {
    applname: "",
    errorMessage: "",
    version: "",
    databasevers: ""
  },
  apiVersion: {
    version: ""
  },
  wbAccess: [],
  limitRecords: {
    minRet: 0,
    maxRet: 0,
    defRet: 0
  }
};

const mutations = {
  setInitPage: (state, payload) => (state.initPage = payload),
  setFullPageLoading: (state, payload) => (state.fullPageLoading = payload),
  setParams: (state, payload) => (state.params = payload),
  setParamsCount: (state, payload) => (state.paramsCount = payload),
  setServerVersion: (state, payload) => (state.serverVersion = payload),
  setApiVersion: (state, payload) => (state.apiVersion = payload),
  setWbAccess: (state, payload) => (state.wbAccess = payload),
  setLimitRecords: (state, payload) => (state.limitRecords = payload)
};

const actions = {
  async ping({ commit, rootState }) {
    try {
      commit("setInitPage", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbUtilLib",
            funcname: "wbPing"
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result != "ok") {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setInitPage", false);
    }
  },
  async getParams({ commit, rootState }, references) {
    try {
      commit("setInitPage", true);

      const call = {
        script: "web.wbParams",
        funcname: "wbRunSelect"
      };
      const params = { ...call, ...references };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setParams", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setInitPage", false);
    }
  },
  async getParamsCount({ commit, rootState }, references) {
    try {
      commit("setInitPage", true);

      const call = {
        script: "web.wbgetparamscount",
        funcname: "wbRunSelect"
      };
      const params = { ...call, ...references };

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setParamsCount", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setInitPage", false);
    }
  },
  async getServerVersion({ commit, rootState }) {
    try {
      commit("setFullPageLoading", true);

      const versionPackage = version.split(".");
      const webVersion = `${versionPackage[1]}.${versionPackage[2]}`;

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbVersion",
            funcname: "wbRunSelect",
            webVersion
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setServerVersion", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getApiVersion({ commit, rootState }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(rootState.auth.base.url, {
        cmd: "getVers"
      });

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setApiVersion", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getWbAccess({ commit, rootState }, { login }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbaccess",
            funcname: "wbAccess",
            plogin: `${login}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setWbAccess", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getLimits({ commit, rootState }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbUtilLib",
            funcname: "wbLimrecord"
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setLimitRecords", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  initPage: state => state.initPage,
  fullPageLoading: state => state.fullPageLoading,
  params: state => state.params,
  serverVersion: state => state.serverVersion,
  apiVersion: state => state.apiVersion,
  wbAccess: state => state.wbAccess,
  limitRecords: state => state.limitRecords
};

export default { state, mutations, actions, getters };
